import { useState } from "react";

import Filter from "./Filter/Filter";
import useSize from "../../../../Utils/useSize/useSize";
import Loading from "../../../../Utils/Loading/Loading";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";

const backend = await new Backend().init();

export default function GenerateBill() {
  const windowSize = useSize();
  const [loading, setLoading] = useState(false);

  const [url, setUrl] = useState("");

  const createPdf = (a, b, c) => {
    setLoading(true);

    let data = {
      id: a,
      start: b,
      end: c,
    };

    backend.createdpdf(data).then((r) => {
      setTimeout(() => {
        setLoading(false);
      }, 5000);
      if (r.error == "False") {
        setTimeout(() => {
          setUrl(r.url);
        }, 5000);
      } else {
        toast.error(r.message);
      }
    });
  };

  return (
    <div>
      <Filter createPdf={createPdf} />

      {loading ? (
        <div
          style={{
            width: windowSize[0],
            height: windowSize[1] - 140,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loading height={windowSize[1] - 160} />
        </div>
      ) : (
        <object
          data={url}
          type="application/pdf"
          width={windowSize[0]}
          height={windowSize[1] - 160}
        >
          <p>
            Alternative text - include a link <a href={url}>to the PDF!</a>
          </p>
        </object>
      )}
    </div>
  );
}
